import { render, staticRenderFns } from "./createWorkflowFromTemplateForm.vue?vue&type=template&id=ef529e84&scoped=true&"
import script from "./createWorkflowFromTemplateForm.vue?vue&type=script&lang=js&"
export * from "./createWorkflowFromTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./createWorkflowFromTemplateForm.vue?vue&type=style&index=0&id=ef529e84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef529e84",
  null
  
)

export default component.exports